import { post } from 'epics/ajax';
import { contextPath } from 'util/history';
import type { Event } from 'util/analytics/types';

export const fireLegacyEvent = (event: Event, context = contextPath): Promise<void> => {
    const uri = `${context}/rest/analytics/1.0/publish/bulk`;
    const body = [event];
    return post(uri, body, { 'Content-Type': 'application/json' })
        .map(({ response }) => response)
        .toPromise();
};
